export const DeviceTypes = {
    SET_DEVICETYPES: "SET_DEVICETYPES",
    ADD_DEVICETYPES: "ADD_DEVICETYPES",
    UPDATE_DEVICETYPES: "UPDATE_DEVICETYPES",
    DELETE_SELECTED_DEVICETYPES: "DELETE_SELECTED_DEVICETYPES",
    
}